import React, { useState } from 'react';
import RemindPasswordMutation from 'mutations/user/remind_password';
import ForgotPasswordForm from 'components/user/authorization/forgot_password_form';
import { Grid, Stack, Alert } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { useMutation } from '@apollo/client/react';
import { CardOptionTypography } from 'components/styles_components/typography';
import { useError } from 'contexts/error';
import {DividerContainer, SectionGrid } from 'components/styles_components/container';

const ForgotPassword = () => {
  const setError = useError();
  const [showSuccess, setShowSuccess] = useState(false);
  const [remindPasswordMutation] = useMutation(RemindPasswordMutation, {
    onCompleted: ({ remindPassword }) => {
      if (remindPassword.success) {
        setShowSuccess(true);
      } else {
        setError('error.user.remind_password');
      }
    },
    onError: () => {
      setError('error.user.remind_password');
    },
  });

  return (
    <Stack>
      <CardOptionTypography variant="h5" align="left">
        <FormattedMessage id="header.user.forgot_password" />
      </CardOptionTypography>
      <DividerContainer />
      <Grid container direction="column" justifyContent="center" alignItems="center">
        <ForgotPasswordForm
          initialValues={{ email: '' }}
          onSubmit={(values, { setSubmitting }) => {
            remindPasswordMutation({ variables: values })
              .then(() => setSubmitting(false))
              .catch(() => setSubmitting(false));
          }}
          processing={showSuccess}
        >
          {showSuccess && (
            <SectionGrid>
              <Alert variant="filled" onClose={() => setShowSuccess(false)} severity="success">
                <FormattedMessage id="info.user.remind_password.success" />
              </Alert>
            </SectionGrid>
          )}
        </ForgotPasswordForm>
      </Grid>
    </Stack>
  );
};

export default ForgotPassword;
